import { render, staticRenderFns } from "./landing-page-how-to-get.vue?vue&type=template&id=7a5fc3bc&scoped=true&lang=pug"
import script from "./landing-page-how-to-get.js?vue&type=script&lang=js&external"
export * from "./landing-page-how-to-get.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-how-to-get.vue?vue&type=style&index=0&id=7a5fc3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5fc3bc",
  null
  
)

export default component.exports